import * as z from 'zod';

export const CheckDomainAvailabilityRequest = z.object({
  domain: z
    .string()
    .describe(
      'Domain name. Must include the TLD. For example, `my-new-domain.com`. Only\nalphanumeric characters, hyphens, and dots are supported.\n\nMin: 3 characters\nMax: 63 characters'
    ),
});
export const CheckDomainAvailabilityResponse = z.object({
  availability: z
    .object({
      domain: z
        .string()
        .describe(
          'Domain name including TLD. For example, `my-new-domain.com`.'
        )
        .optional(),
      available: z
        .boolean()
        .describe(
          'Whether the domain is available for purchase. You can purchase the\ndomain in case the boolean is `true`. The domain is already taken\nwhen `false` is returned.'
        )
        .optional(),
      premium: z
        .boolean()
        .describe(
          'Whether the domain has a higher price due to its perceived value or demand.'
        )
        .optional(),
      premiumType: z
        .enum(['FIRST_YEAR_ONLY', 'FIRST_YEAR_AND_RENEWAL'])
        .describe(
          'In case the domain is premium the premium_type will represent the type of the premium domain.\nFIRST_YEAR_ONLY - only initial purchase price is  premium while the renewal will cost the regular price of the TLD.\nFIRST_YEAR_AND_RENEWAL - both initial purchase and renewal prices are premium.'
        )
        .optional(),
    })
    .describe("Information about the domain's availability.")
    .optional(),
});
